/* ─────────────────────────────────────────────────────────────────────────
   data.js  –  window.EMK_CONFIG'ten okur (public/config.js)
   Firma bilgilerini değiştirmek için build gerekmez:
   Hostingde doğrudan public_html/config.js dosyasını düzenleyin.
   ───────────────────────────────────────────────────────────────────────── */

const C = window.EMK_CONFIG || {};

/* ── Güvenli okuma yardımcısı ── */
const get = (val, fallback) => (val !== undefined && val !== null && val !== '') ? val : fallback;

export const COMPANY = {
  name:      get(C.name,      'EMK Asansör'),
  slogan:    get(C.slogan,    'Güvenli Yükseliş'),
  phone:     get(C.phone,     '0212 871 72 81'),
  mobile:    get(C.mobile,    '0532 308 04 67'),
  email:     get(C.email,     'Emkasansorr@hotmail.com'),
  address:   get(C.address,   'Siyavuşpaşa Mah. Çavuşpaşa Köprüyolu Cad. No:17/B'),
  workHours: get(C.workHours, 'Her gün 7/24 Hizmetinizdeyiz'),
  mapEmbed:  get(C.mapEmbed,  'https://maps.google.com/?q=Istanbul'),
  founded:   get(C.founded,   2006),
  social: {
    whatsapp:  get(C.social?.whatsapp,  'https://wa.me/902125550100'),
    instagram: get(C.social?.instagram, 'https://instagram.com'),
    facebook:  get(C.social?.facebook,  'https://facebook.com'),
    linkedin:  get(C.social?.linkedin,  'https://linkedin.com'),
  },
};

export const STATS = Array.isArray(C.stats) ? C.stats : [
  { value: '850+', label: 'Tamamlanan Proje' },
  { value: '18',   label: 'Yıllık Deneyim'   },
  { value: '7/24', label: 'Teknik Destek'    },
  { value: '12',   label: "İl'de Hizmet"     },
];

export const HERO = C.hero || {
  badge:  'İstanbul & Çevre İller · Kurumsal Asansör Çözümleri',
  title1: 'Her Katta',
  title2: 'Güvenli',
  title3: 'Yükseliş.',
  desc:   '18 yıllık deneyimimizle asansör montajı, periyodik bakım ve modernizasyon hizmetlerinde 850\'yi aşkın projeyi başarıyla teslim ettik.',
};

export const SERVICES = Array.isArray(C.services) ? C.services.map((s, i) => ({ id: s.id || `svc-${i}`, ...s })) : [
  { id: 'montaj',       icon: '⬆',  title: 'Asansör Montajı',    short: 'CE sertifikalı konut ve ticari asansör kurulumu.',          desc: 'Konut, ofis ve ticari binalara özel CE sertifikalı kurulum.',      features: ['Konut & ticari asansörler','Yük ve servis asansörleri','Engelli erişim platformları','Panoramik cam asansörler'] },
  { id: 'bakim',        icon: '🔧', title: 'Periyodik Bakım',     short: 'Yılda 4 zorunlu bakım, 7/24 arıza müdahalesi.',            desc: 'Yılda 4 periyodik bakım, 7/24 arıza müdahalesi, yedek parça.',   features: ['Yılda 4 zorunlu periyodik bakım','7/24 arıza müdahalesi','Orijinal yedek parça garantisi','Dijital bakım takip sistemi'] },
  { id: 'modernizasyon',icon: '🔄', title: 'Modernizasyon',       short: 'Eski asansörleri enerji verimli sistemlere dönüştürme.',   desc: "Eski sistemleri akıllı ve enerji verimli hale dönüştürüyoruz.", features: ['Frekans invertör montajı','LED kabin aydınlatması','Akıllı çağrı sistemleri','Enerji geri kazanım modülü'] },
  { id: 'muayene',      icon: '📋', title: 'Teknik Muayene',      short: 'Bakanlık onaylı periyodik muayene ve TSE belgelendirme.',  desc: 'Bakanlık onaylı teknik muayene ve TSE belgelendirme.',           features: ['Yıllık zorunlu teknik muayene','TSE belgelendirme desteği','Resmi muayene raporu','Uygunsuzluk düzeltme danışmanlığı'] },
  { id: 'proje',        icon: '🏗', title: 'Proje & Tasarım',     short: 'Mimari entegrasyon ve müteahhit danışmanlığı.',            desc: 'Mimari entegrasyon, şaft tasarımı ve teknik çizim hizmetleri.', features: ['Şaft ve makine dairesi tasarımı','Statik yük hesabı desteği','AutoCAD teknik çizimler','Ruhsat süreç danışmanlığı'] },
  { id: 'guvenlik',     icon: '🛡', title: 'Güvenlik Sistemleri', short: 'ARF kurtarma, interkom ve acil aydınlatma.',              desc: 'ARF kurtarma, dijital interkom, acil aydınlatma ve alarm.',     features: ['ARF otomatik kurtarma','Dijital interkom & kamera','Acil aydınlatma sistemi','Uzaktan izleme & alarm'] },
];

export const TEAM = Array.isArray(C.team) ? C.team : [
  { initials: 'EK', name: 'Emre Kaya',    role: 'Kurucu & Genel Müdür'  },
  { initials: 'MÇ', name: 'Murat Çelik',  role: 'Teknik Direktör'       },
  { initials: 'AD', name: 'Ayşe Demir',   role: 'Proje Koordinatörü'    },
  { initials: 'KA', name: 'Kemal Arslan', role: 'Baş Teknisyen'         },
  { initials: 'SY', name: 'Selin Yıldız', role: 'Müşteri İlişkileri'    },
  { initials: 'BT', name: 'Berk Tekin',   role: 'Saha Teknisyeni'       },
];

export const TIMELINE = Array.isArray(C.timeline) ? C.timeline : [
  { year: '2006', text: "İstanbul Bağcılar'da EMK Asansör kuruldu."        },
  { year: '2010', text: "TSE ve CE sertifikaları alındı."                   },
  { year: '2015', text: "İstanbul dışına açılım başladı, 5 yeni il."       },
  { year: '2019', text: "ISO 9001:2015 belgesi alındı, 500. proje."        },
  { year: '2020', text: "7/24 teknik destek hattı devreye girdi."          },
  { year: '2024', text: "850+ proje, 12 il, ISO 9001 yenileme."            },
];

export const CERTIFICATIONS = Array.isArray(C.certifications) ? C.certifications : [
  'TSE Belgeli', 'CE Sertifikalı', 'ISO 9001:2015', '7/24 Destek', 'Bakanlık Onaylı', 'Yetkili Servis',
];

export const ABOUT = C.about || {
  eyebrow: 'Hikayemiz',
  heading: "2006'dan Bu Yana Güvenilir Yükseliş",
  paragraphs: [
    "EMK Asansör, İstanbul'da küçük bir ekiple kuruldu. Bugün İstanbul'un 39 ilçesinde 850'yi aşkın projeyi tamamlamış, TSE ve CE sertifikalı ekibimizle Türkiye'nin güvenilir asansör firmalarından biri haline geldik.",
    "Konut projelerinden ticari binalara, hastanelerden endüstriyel tesislere kadar geniş bir referans portföyüyle hizmet veriyoruz.",
    "Müşterilerimize proje tasarımından periyodik bakıma, teknik muayeneden modernizasyona tam kapsamlı asansör çözümleri sunuyoruz."
  ]
};

export const PROJECTS = Array.isArray(C.projects) ? C.projects : [
  { image: 'insan-asansoru.jpg', title: 'İnsan Asansörü', location: 'İstanbul', category: 'insan', categoryLabel: 'İnsan Asansörü', desc: 'Konut ve ticari binalar için konforlu yolcu taşıma asansörleri.' },
  { image: 'yuk-asansoru.jpg', title: 'Yük Asansörü', location: 'İstanbul', category: 'yuk', categoryLabel: 'Yük Asansörü', desc: 'Endüstriyel tesisler için yüksek kapasiteli yük asansörleri.' },
  { image: 'platform-asansoru.jpg', title: 'Platform Asansörü', location: 'İstanbul', category: 'platform', categoryLabel: 'Platform Asansörü', desc: 'Engelli erişimi için güvenli platform sistemleri.' },
  { image: 'yemek-asansoru.jpg', title: 'Yemek Asansörü', location: 'İstanbul', category: 'yemek', categoryLabel: 'Yemek Asansörü', desc: 'Mutfaklar için monşarj asansör sistemleri.' },
];

export const NAV_LINKS = [
  { label: 'Ana Sayfa',     path: '/'           },
  { label: 'Hizmetlerimiz', path: '/hizmetler'  },
  { label: 'Projelerimiz',  path: '/projeler'   },
  { label: 'Hakkımızda',    path: '/hakkimizda' },
  { label: 'İletişim',      path: '/iletisim'   },
];
